var _style, _path, _polygon, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVitaminDSupplement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EF9062;}\n\t.st1{fill:#EFC05D;}\n\t.st2{fill:#F6DAA2;}\n\t.st3{fill:#AA1A18;}\n\t.st4{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.19,184.66c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C27.89,150.37,62.5,184.66,105.19,184.66"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "97.74,138.52 85,146.44 83.27,131.55 68.36,133.16 73.24,118.98 59.11,113.96 69.67,103.31  59.11,92.67 73.24,87.65 68.36,73.47 83.27,75.08 85,60.19 97.73,68.11 105.78,55.46 113.82,68.11 126.55,60.19 128.28,75.08  143.19,73.47 138.31,87.65 152.44,92.67 141.88,103.31 152.44,113.96 138.31,118.98 143.19,133.15 128.28,131.54 126.55,146.44  113.82,138.52 105.78,151.17 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 105.78,
    cy: 103.31,
    r: 24.97
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M146.22,121.2c2.02,3.53,2.41,7.52,1.42,11.15c-0.99,3.63-3.37,6.88-6.89,8.89l-36.73,21 c-0.61,0.35-1.24,0.65-1.89,0.9l14.28-8.17c3.53-2.02,5.9-5.26,6.89-8.89c0.98-3.62,0.59-7.63-1.42-11.15 c-3.67-6.42-11.46-9.03-18.15-6.37l22.43-12.83C133.22,111.71,142.2,114.15,146.22,121.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M121.89,134.93c2.01,3.52,2.4,7.52,1.42,11.15c-0.99,3.63-3.36,6.87-6.89,8.89l-14.28,8.17 c-6.68,2.66-14.47,0.07-18.15-6.36c-2.02-3.53-2.41-7.53-1.42-11.15c0.99-3.62,3.37-6.88,6.89-8.89l14.29-8.17 C110.43,125.91,118.22,128.51,121.89,134.93z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitaminDSupplement);
export default __webpack_public_path__ + "static/media/Vitamin_D_supplement.db7bb4679b3edf65e27fe89a527e637a.svg";
export { ForwardRef as ReactComponent };